module.exports = __webpack_public_path__ + "static/media/BobabarProcess3.8776d415.jpg";